import FAQ from './FAQ';
import Route from './route';

export default {
  RenderProp: FAQ,
  mainRoute: Route,
};
